import { Breadcrumb, Layout, Typography } from 'antd';

import { FeatureFlags, PageLayout } from '@app/web-components';

import { NotFoundPage } from '../../common';

export const LandingPage = () => {
  const { getBreadcrumbProps, getContentProps, getTitleProps } = PageLayout.useGetPageLayout('landing');
  const { isFeatureEnabled } = FeatureFlags.useFeatureFlags();

  if (!isFeatureEnabled('faceless-audit')) {
    return <NotFoundPage />;
  }

  return (
    <>
      <Breadcrumb {...getBreadcrumbProps({ items: [{ title: 'Admin' }, { title: 'Faceless Audit' }] })} />
      <Layout.Content {...getContentProps()}>
        <Typography.Title {...getTitleProps()}>Faceless Audit</Typography.Title>
      </Layout.Content>
    </>
  );
};
